const BEDROOMS = {

  id: "bedrooms",
  type: "dropdown",
  props: {
    isMulti: true,
    dropdownProps: {
      label: "Bedroom",
      buttonProps: {
        className: "bedrooms",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "1", value: 1 },
      { label: "2", value: 2 },
      { label: "3", value: 3 },
      { label: "4", value: 4 },
      { label: "5", value: 5 },
      { label: "6+", value: 6 },
    ],
  }

}

const COL_BEDROOMS = {

  id: "col_bedrooms",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [BEDROOMS]

}

const COL_MODAL_BEDROOMS = {

  id: "col_bedrooms",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [BEDROOMS]

}

export { BEDROOMS, COL_BEDROOMS, COL_MODAL_BEDROOMS };
